import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postAgent20 } from "./VipEvaluateCommissionCRUD";
import { vipEvaluateSlice } from "./VipEvaluateCommissionSlice";

const { actions } = vipEvaluateSlice;

export const clearVipEvaluateList = () => (dispatch) => {
  dispatch(actions.vipEvaluateListFetched({ data: null }));
};

export const fetchVipEvaluateUI = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent20(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipEvaluateUIFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipEvaluateUI");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const fetchVipEvaluateList =
  (queryParams, isClear = true) =>
  (dispatch) => {
    dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));
    if (isClear) dispatch(actions.vipEvaluateListFetched({ data: null }));

    return postAgent20(queryParams)
      .then((response) => {
        if (response) {
          if (!response.data.isAbort) {
            dispatch(actions.vipEvaluateListFetched({ data: response.data }));
            return response;
          }
        } else {
          throw new Error("Error api: fetchVipEvaluateList");
        }
      })
      .catch((error) => {
        dispatch(
          actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
        );
        throw error;
      });
  };

export const fetchVipEvaluateEffList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent20(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipEvaluateEffListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipEvaluateEffList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const publishVipEvaluate = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent20(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipEvaluatePublished());
          return response;
        }
      } else {
        throw new Error("Error api: publishVipEvaluate");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
